import {
  branch,
  compose, renderNothing, withHandlers,
} from 'recompose';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  always, ifElse, isEmpty, isNil,
} from 'ramda';

import PinTaskModal from './unpinTaskModal';
import { getModal } from '../../../state/ui/selectors';
import { uiActions } from '../../../state/ui';
import { tasksActions } from '../../../state/tasks';
import { projectSelectors } from '../../../state/project';
import { taskSelectors } from '../../../state/task';

const mapDispatchToProps = {
  onCloseModal: uiActions.closeModal,
  unpinTaskRequest: tasksActions.unpinTaskRequest,
};

const mapStateToProps = (state, { selectedTask }) => {
  const taskActive = taskSelectors.getActiveTask(state);
  const taskById = projectSelectors.getTask(state)(selectedTask).id
    ? projectSelectors.getTask(state)(selectedTask)
    : projectSelectors.getBacklogTask(state)(selectedTask);

  return {
    isOpen: getModal(state)('unpinTaskModal'),
    task: ifElse(isEmpty, always(taskActive), always(taskById))(taskById),
  };
};


const onUnpinHandler = ({
  unpinTaskRequest, onClose, task,
}) => () => unpinTaskRequest({
  taskId: task.id,
  projectId: task.project_id,
}, {
  callbacks: {
    success: () => {
      onClose();
    },
  },
});

const onCloseHandler = ({ onCloseModal }) => () => onCloseModal('unpinTaskModal');

const enhance = compose(
  branch(
    ({ selectedTask }) => isNil(selectedTask),
    renderNothing,
  ),
  connect(mapStateToProps, mapDispatchToProps),
  withRouter,
  withHandlers({
    onClose: onCloseHandler,
  }),
  withHandlers({
    onUnpin: onUnpinHandler,
  }),
);


export default enhance(PinTaskModal);
